import {
    GET_ACTIONS_FAIL,
    GET_ACTIONS_SUCCESS,
    ADD_ACTION_SUCCESS,
    ADD_ACTION_FAIL,
    UPDATE_ACTION_SUCCESS,
    UPDATE_ACTION_FAIL,
    DELETE_ACTION_SUCCESS,
    DELETE_ACTION_FAIL,
   
} from "./actionTypes";

const INIT_STATE = {
    actions: [],
    error: {},
    loading: true
}

const actionReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_ACTIONS_SUCCESS:
            return {
                ...state,
                actions: action.payload,
                loading: true
            };

        case GET_ACTIONS_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case ADD_ACTION_SUCCESS:
            return {
                ...state,
                actions: [action.payload, ...state.actions],
            };

        case ADD_ACTION_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case UPDATE_ACTION_SUCCESS:
            return {
                ...state,
                actions: state.actions.map(action =>
                    action.id.toString() === action.payload.id.toString()
                        ? { action, ...action.payload }
                        : action
                ),
            };

        case UPDATE_ACTION_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case DELETE_ACTION_SUCCESS:
            return {
                ...state,
                actions: state.actions.filter(
                    action => action.id.toString() !== action.payload.toString()
                ),
            };

        case DELETE_ACTION_FAIL:
            return {
                ...state,
                error: action.payload,
            };
       
        default:
            return state
    }
}

export default actionReducer;